var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEcoLockedTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 18h-2v3h15v-3h-2v-3l-3.39-3L53 9V6h2V3H40v3h2v3l3.39 3L42 15v3zm3-10.32V6h5v1.68l-2.5 2.18L45 7.68zm0 8.64l2.5-2.18 2.5 2.18V18h-5v-1.68zm27-8.71a5.498 5.498 0 00-7.568-5.137A5.5 5.5 0 0061 7.53V9h-2v12h15V9h-2V7.61zM68 18h-3v-6h3v6zm1-9h-5V7.53a2.48 2.48 0 011-2 2.49 2.49 0 014 2.1V9zM32.28 26.1a20.93 20.93 0 0024.38 29 20.18 20.18 0 01-9.89 7.06c-10.92 3.53-22.72-2.73-26.36-14-3.64-11.27 2.26-23.24 13.18-26.77.71-.223 1.43-.407 2.16-.55a20.92 20.92 0 00-3.47 5.26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco_locked_timer.cdba228e.svg";
export { SvgF1ModeEcoLockedTimer as ReactComponent };